module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/968680284c4fc84e16ab59b33e9515d4.png";